import { Box, Button, Grid, Paper, Stack, Typography, TextField } from "@mui/material";
import DashboardCard from "components/molecules/dashboardCard/DashboardCard";
import React from "react";
import CustomButton from "components/atoms/CustomButton";
import CustomMenu from "components/atoms/CustomMenu";
import SearchBar from "components/atoms/SearchBar";
import PrintIcon from "@mui/icons-material/Print";

import Pagination from "components/molecules/pagination/Pagination";
import { useQueryClient } from "react-query";
import { exportToExcel } from "utils/exportToExcel";

import {
  GET_ACCOUNTING_DETAILS,
  GET_ALL_PAID_TRANSACTIONS,
  GET_ALL_PENDING_TRANSACTIONS,
} from "utils/reactQueryKeys";

import OverviewTable from "components/molecules/tabels/accounting/AllTransOverviewTable";
import { useCustomQuery } from "store/hooks/react-query/query/useQuery";
import CustomLoader from "components/atoms/CustomLoader";

import { ShoppingCartCheckout } from "@mui/icons-material";
import {
  PaperDocIcon,
  PendingIcon,
  WalletIcon,
} from "components/Assets/generated";
import { numberFormatter } from "utils/numberFormatter";

import AccountingTransactionHistoryTable from "components/molecules/tabels/accounting/TransactionHistory";
import { useSanitizeQueryParams } from "utils/sanitizeQuery";

let PageSize = 10;

const transactionTypeOptions = [
  {
    name: "HMO",
    value: "HMO",
  },
  {
    name: "CASH",
    value: "CASH",
  },
  {
    name: "CARD",
    value: "CARD",
  },
];

const formatExportData = (data) => {
  if (data?.length) {
    return data?.map((d) => {
      const formartedData = {
        totalCost: d?.totalCost,
        PatientsName: `${d?.patient?.firstName} ${d?.patient?.lastName}`,
        PatientID: `${d?.patient?.ID}`,
        PatientPhone: `${d?.patient?.phoneNumber}`,
      };
      return formartedData;
    });
  }
  return [];
};
const formatExportData1 = (data) => {
  if (data?.length) {
    const result = data?.map((d) => {
      const formartedData = {
        ...d,
        PatientsName: `${d?.patient?.firstName} ${d?.patient?.lastName}`,
        PatientID: `${d?.patient?.ID}`,
      };
      delete formartedData.patient;
      delete formartedData.id;
      delete formartedData.itemToPayFor;
      delete formartedData.model;
      return formartedData;
    });

    return result;
  }
  return [];
};

function AccountingOverview() {
  const [search, setsearch] = React.useState("");
  const [search1, setsearch1] = React.useState("");
  const [transactionType, settransactionType] = React.useState({});

  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");

  const [currentPage, setCurrentPage] = React.useState(1);
  const [currentPage1, setCurrentPage1] = React.useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handlePageChange1 = (page) => {
    setCurrentPage1(page);
  };

  //handle export
  const handleExport = () => {
    exportToExcel(
      formatExportData(allTransactions?.data?.patientPayments),
      "pending_payments"
    );
  };
  //handle export
  const handleExport1 = () => {
    exportToExcel(
      formatExportData1(paidTransactions?.data?.payments),
      "transaction_history"
    );
  };
  const handleReset = () => {
    settransactionType({});
    setsearch1("");
    setStartDate("");
    setEndDate("");
  };

  //get pending transactions
  const {
    data: allTransactions,
    isLoading: getAllTransactionsLoading,
    isFetching: isPendingFetching,
    isError,
  } = useCustomQuery(
    [
      GET_ALL_PENDING_TRANSACTIONS,
      {
        page: currentPage,
        limit: PageSize,
        search,
        startDate, 
        endDate, 
      },
    ],
    {
      url: `/payment/accounting-overview`,
      method: "post",
      data: {
        page: currentPage,
        limit: PageSize,
        search,
        startDate, 
        endDate, 
      },
    },
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    }
  );

  //get paid transactions
  const {
    data: paidTransactions,
    isLoading: getpaidTransactionsLoading,
    isFetching: ishistoryFetching,
    isError: paidTransactionsErr,
  } = useCustomQuery(
    [
      GET_ALL_PAID_TRANSACTIONS,
      {
        page: currentPage1,
        search: search1,
        paymentMethod: transactionType?.value,
        startDate, 
        endDate, 
      },
    ],
    {
      url: useSanitizeQueryParams(
        `/payment/payment-history?paymentMethod=${transactionType?.value}&limit=${PageSize}&page=${currentPage1}&search=${search1}&startDate=${startDate}&endDate=${endDate}`
      ),
      method: "get",
    },
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    }
  );

  //get all accounting details
  const { data: accountDetails } = useCustomQuery(
    [GET_ACCOUNTING_DETAILS],
    {
      // url: `/payment/payment-data`,
      url: `/accounting/account-details`,
      method: "post",
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  return (
    <Box>
      <Stack
        direction="row"
        justifyContent={"flex-start"}
        sx={{ width: "100%" }}
        spacing={1}
      >
        <Typography variant="displayLg">Overview</Typography>
      </Stack>

      <Grid container spacing={1} sx={{ mt: 2 }}>
        <Grid item xs={12} sm={6} lg={3}>
          <DashboardCard
            // url="/home/accounting/requisitions"
            icon={
              <PendingIcon style={{ color: "#008435", fontSize: "30px" }} />
            }
            smallTxt="Pending Order"
            bigTxt={numberFormatter(
              accountDetails?.data?.numberOfPendingOrders || 0
            )}
            icnBgSx={{
              backgroundColor: "rgba(0, 132, 53, 0.1)",
            }}
            smallTxtSx={{
              fontWeight: "400",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <DashboardCard
            // url="/home/accounting/requisitions"
            icon={
              <ShoppingCartCheckout
                sx={{ color: "#FF8160", fontSize: "30px" }}
              />
            }
            icnBgSx={{
              backgroundColor: "rgba(219, 30, 54, 0.1)",
            }}
            smallTxtSx={{
              fontWeight: "400",
            }}
            smallTxt="Successful Order"
            bigTxt={numberFormatter(
              accountDetails?.data?.numberOfSuccessfulPayments || 0
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <DashboardCard
            url=""
            icon={
              <PaperDocIcon style={{ color: "#1B4AF0", fontSize: "30px" }} />
            }
            icnBgSx={{
              backgroundColor: "rgba(27, 74, 240, 0.1)",
            }}
            smallTxtSx={{
              fontWeight: "400",
            }}
            smallTxt="Total Expense"
            bigTxt={`₦${numberFormatter(
              accountDetails?.data?.totalExpenses || 0,
              9
            )}`}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <DashboardCard
            icon={<WalletIcon style={{ color: "black", fontSize: "30px" }} />}
            url=""
            icnBgSx={{
              backgroundColor: "rgba(2, 0, 17, 0.1)",
            }}
            smallTxtSx={{
              fontWeight: "400",
            }}
            smallTxt="Total income"
            bigTxt={`₦${numberFormatter(
              accountDetails?.data?.totalIncome || 0,
              9
            )}`}
          />
        </Grid>

        {/* START: Date Filter Section */}
        <Grid item xs={12}>
           <Paper sx={{ p: 2, mt: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography variant="caption" sx={{ fontWeight: 'bold' }}>Filter Date:</Typography>
              <TextField
                type="date"
                size="small"
                label="Start Date"
                InputLabelProps={{ shrink: true }}
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
              <TextField
                type="date"
                size="small"
                label="End Date"
                InputLabelProps={{ shrink: true }}
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
              <Button variant="outlined" onClick={handleReset}>Reset Filters</Button>
           </Paper>
        </Grid>
        {/* END: Date Filter Section */}

        <Grid item xs={12}>
          {getAllTransactionsLoading ? (
            <CustomLoader />
          ) : isError ? (
            <Paper sx={{ p: 1, mt: 2 }}>
              <Typography>
                Something went wrong, refresh and try again Later
              </Typography>
            </Paper>
          ) : (
            <Paper sx={{ p: 4, mt: 2 }}>
              <Stack direction="column" spacing={2}>
                <Typography variant="displaySm">
                  Pending Transactions
                </Typography>

                <Stack
                  direction={{ xs: "column", lg: "row" }}
                  spacing={2}
                  sx={{ width: "100%" }}
                  justifyContent={{ lg: "flex-end" }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    spacing={1}
                  >
                    <SearchBar
                      search={search}
                      setsearch={setsearch}
                      placeholder="Search Patient Name"
                      isLoading={isPendingFetching}
                    />
                    <CustomButton
                      startIcon={<PrintIcon />}
                      text={"Export"}
                      variant="outlined"
                      disabled={
                        allTransactions?.data?.patientPayments?.length === 0
                      }
                      onClick={handleExport}
                    />
                  </Stack>
                </Stack>
              </Stack>

              {allTransactions?.data?.patientPayments.length ? (
                <>
                  <OverviewTable
                    data={allTransactions?.data?.patientPayments}
                  />
                  <Box sx={{ p: { xs: 0, sm: 2 } }}>
                    <Pagination
                      currentPage={currentPage}
                      totalCount={allTransactions?.data?.count}
                      pageSize={10}
                      onPageChange={handlePageChange}
                      activeColor={"secondary.main"}
                    />
                  </Box>
                </>
              ) : (
                <Typography>No item to display</Typography>
              )}
            </Paper>
          )}
        </Grid>
        {/* Paid transactions */}
        <Grid item xs={12}>
          {paidTransactionsErr ? (
            <Paper sx={{ p: 1, mt: 2 }}>
              <Typography>No item to display</Typography>
            </Paper>
          ) : getpaidTransactionsLoading ? (
            <CustomLoader />
          ) : (
            <Paper sx={{ p: 4, mt: 2 }}>
              <Stack direction="column" spacing={2}>
                <Typography variant="displaySm">Transaction History</Typography>

                <Stack
                  direction={{ xs: "column", lg: "row" }}
                  spacing={2}
                  sx={{ width: "100%" }}
                  justifyContent="flex-end"
                >
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    spacing={1}
                  >
                    <SearchBar
                      search={search1}
                      setsearch={setsearch1}
                      placeholder="Search Patient Name"
                      isLoading={ishistoryFetching && !!search1}
                    />

                    <CustomMenu
                      caption={transactionType.name || "Payment Method"}
                      items={transactionTypeOptions}
                      onClickItem={(data) => settransactionType(data)}
                      popperSx={{
                        width: {
                          xs: "40%",
                          md: "12.4%",
                        },
                      }}
                      disabled={ishistoryFetching}
                    />
                    <CustomButton
                      text={"Reset"}
                      variant="outlined"
                      onClick={handleReset}
                    />
                    <CustomButton
                      startIcon={<PrintIcon />}
                      text={"Export"}
                      variant="outlined"
                      disabled={paidTransactions?.data?.payments?.length === 0}
                      onClick={handleExport1}
                    />
                  </Stack>
                </Stack>
              </Stack>

              {paidTransactions?.data?.payments?.length ? (
                <>
                  <AccountingTransactionHistoryTable
                    data={paidTransactions?.data?.payments}
                  />
                  <Box sx={{ p: { xs: 0, sm: 2 } }}>
                    <Pagination
                      currentPage={currentPage1}
                      totalCount={paidTransactions?.data?.count}
                      pageSize={10}
                      onPageChange={handlePageChange1}
                      activeColor={"secondary.main"}
                    />
                  </Box>
                </>
              ) : (
                <Typography>No item to display</Typography>
              )}
            </Paper>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}

AccountingOverview.defaultProps = {
  pieData1: [
    {
      name: "Total Admitted Patient",
      fill: "#2F80ED",
      value: 1000,
    },
    {
      name: "Discharged  Patient",
      fill: "#EEA339",
      value: 200,
    },
  ],
  pieData: [
    {
      name: "Number of Occupied Beds",
      fill: "#092C4C",
      value: 1000,
    },
    {
      name: "Number of Unoccupied Beds",
      fill: "#457EE8",
      value: 200,
    },
  ],

  dropDownContent: [
    {
      name: "Daily",
      value: "Day",
    },
    {
      name: "Weekly",
      value: "Week",
    },
    {
      name: "Monthly",
      value: "Month",
    },
  ],
  lineData: [
    {
      name: "Monday",
      "Number of Patients": 3500,
    },
    {
      name: "Tuesday",
      "Number of Patients": 3000,
    },
    {
      name: "Wednesday",
      "Number of Patients": 2000,
    },
    {
      name: "Thursday",
      "Number of Patients": 2780,
    },
    {
      name: "Friday",
      "Number of Patients": 1890,
    },
    {
      name: "Saturday",
      "Number of Patients": 2390,
    },
    {
      name: "Sunday",
      "Number of Patients": 3490,
    },
  ],
};
export default AccountingOverview;
